import { Phone, ArrowRight } from "lucide-react";
import logoAsset from "@/assets/hill-brothers-logo.png.asset.json";

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <img
        src="/usa_flag.jpg"
        alt=""
        width="1920"
        height="1080"
        {...({ fetchpriority: "high" } as Record<string, string>)}
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="flag-overlay" aria-hidden="true" />

      <div className="relative z-10 section-container py-20">
        <div className="hero-card max-w-3xl mx-auto text-center">
          <img
            src={logoAsset.url}
            alt="Hill Brothers Painting & Contracting logo"
            width="720"
            height="720"
            {...({ fetchpriority: "high" } as Record<string, string>)}
            decoding="async"
            className="mx-auto mb-6 w-52 md:w-64 h-auto rounded-xl"
          />

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-foreground mb-4 animate-fade-in">
            Professional Painting & Contracting in New Hampshire
          </h1>

          <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto animate-fade-in" style={{ animationDelay: "0.2s" }}>
            When you hire our services, you can count on us for the results you want and need. Get in touch today, and discover the advantage of working with Hill Brothers Painting.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in" style={{ animationDelay: "0.3s" }}>
            <a href="#contact" className="btn-primary">
              Contact Us
              <ArrowRight className="w-5 h-5" aria-hidden="true" />
            </a>

            <a href="tel:+16034244608" className="phone-link">
              <Phone className="w-5 h-5" aria-hidden="true" />
              <span>603 424 4608</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
